class AvailabilityPopup extends HTMLElement {
    constructor() {
        super()
        this.showAvailables = false
        this.setListeners()
    }

    setListeners() {
        document.addEventListener("DOMContentLoaded", () => {
            this.searchInput = this.querySelector('.pickup-popup__search input')
            this.filterCheckbox = this.querySelector('.pickup-popup__filter input')
            this.locations = this.querySelectorAll('.pickup-popup__location')
            this.closeBtn = this.querySelector('#PickupPopupClose')

            this.searchInput?.addEventListener('input', this.onSearchInputChange.bind(this))
            this.filterCheckbox?.addEventListener('input', this.onFilterCheckboxChange.bind(this))
            this.closeBtn?.addEventListener('click', () => {
                this.querySelector('details')?.removeAttribute('open')
            })
        })
    }

    handleize(string) {
        if(!string) return ''
        return string.toLowerCase().replaceAll(/[^a-zA-Z0-9]/g, '').replaceAll(' ', '')
    }

    onSearchInputChange() {
        this.locations.forEach(location => {
            let nameHandle = this.handleize(location.dataset.name)
            let addressHandle = this.handleize(location.dataset.address)
            let cityHandle = this.handleize(location.dataset.city)
            let inputHandle = this.handleize(this.searchInput.value)

            if(this.showAvailables && !!!location.dataset.available) {
                location.classList.add('hidden')
                return
            }

            if((nameHandle.includes(inputHandle) && !!nameHandle) || (addressHandle.includes(inputHandle) && !!addressHandle) || (cityHandle.includes(inputHandle) && !!cityHandle)) {
                location.classList.remove('hidden')
            }else {
                location.classList.add('hidden')
            }
        })
    }

    onFilterCheckboxChange() {
        this.showAvailables = this.filterCheckbox.checked
        this.onSearchInputChange()
    }
}

customElements.define('availability-popup', AvailabilityPopup)